import { on } from 'delegated-events';

import showPopup from './modals';
import smallCartRefresh from './cart/small-cart-refresh';
import { showLoader, hideLoader } from './utils/utils';
import { sendAddedToCart } from './utils/algolia-attribution';

export default function () {
    on('click', '.cartadder', function () {
        showLoader();

        const scope = this.closest('[data-scope="addcart"]');
        let amount = 1;

        if (scope.querySelector('[data-optionid]') && scope.querySelector('[data-optionid]').getAttribute('data-optionid') === '-1') {

            showPopup({
                body: 'Proszę wybrać opcję produktu',
                overloadClass: 'error-modal'
            });

            hideLoader();
            return;
        }

        let setGuid = '';
        const additionalSetSelector = scope.querySelector('.detail-options');

        if (additionalSetSelector) {
            const selected = additionalSetSelector.querySelector('.selected');
            if (selected) {
                setGuid = selected.getAttribute('data-set-guid');
            }
        }

        const requestBody = {
            request: {
                Amount: amount,
                setId: setGuid,
                ProductId: scope.querySelector('[data-pid]').getAttribute('data-pid'),
                OptionId: scope.querySelector('[data-optionid]') ? scope.querySelector('[data-optionid]').getAttribute('data-optionid') : null
            }
        };

        const requestAddons = [];

        scope.querySelectorAll('[data-cart-custom]').forEach(dataCart => {
            requestAddons.push({
                key: dataCart.getAttribute('data-cart-custom'),
                value: dataCart.value
            });
        });

        requestBody.request['addons'] = requestAddons;

        fetch('/cartaction/addcart', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(response => response.json())
            .then(data => {

                hideLoader();

                if (data.RedirectToUrl) {
                    location.href = data.ProductUrl;
                    return false;
                }

                if (data.ErrorMessage) {
                    showPopup({ body: data.ErrorMessage, overloadClass: 'error-modal' });
                    smallCartRefresh();
                    return false;
                }

                showPopup({
                    header: 'Dodano do koszyka!',
                    body: data.HtmlResponse,
                    overloadClass: 'cart-modal success-modal',
                    anotherCloseSelector: '.simple-link',
                });

                if (data.PositionChanges) {
                    for (const item of data.PositionChanges) {

                        document.dispatchEvent(new CustomEvent('goshop:cart_action', { detail: item }));

                    }
                }

                // Algolia: always fire an addToCart event. Routes to the
                // *AfterSearch* variant if we have stored search-click
                // attribution for this objectID, otherwise the generic one.
                const optionId = requestBody.request.OptionId;
                if (optionId) {
                    sendAddedToCart(optionId, {
                        quantity: requestBody.request.Amount,
                        currency: 'PLN'
                    });
                }

                smallCartRefresh({ force: true });
            })
            .catch(error => {
                hideLoader();
                console.log(error);
            });
    });
}